import container from '../container/container';
import preloader from '../preloader/preloader';

const sliderListCut = function (id) {
    let publicVars = {};
    const privateVars = {
        name: 'slider-list-cut(' + id + ')',
        itemsCount: 0,
        firstItem: 0,
        lastItem: 0,
        itemWidth: 0,
        modifier: 0,
        isAnimating: true,
        itemsVisible: 1,
        items: [],
        itemsSetDeviation: 1,
        itemsCountTillReset: 0,
        callbacks: [],
        imgPreload: new Map()
    };

    const methods = {
        init: (options) => {
            container.msg(privateVars.name, 'init');

            publicVars = container.performCopy(publicVars, options);

            preloader.init();

            methods.bind();

            methods.startup();

            methods.preloadImages();
        },

        bind: function () {
            let resizeRAF;

            document.querySelector(publicVars.cssId.arrowLeftId).addEventListener('click', function (event) {
                container.msg(privateVars.name, 'arrow left click');

                methods.actionMoveSlider('left');
            });

            document.querySelector(publicVars.cssId.arrowRightId).addEventListener('click', function (event) {
                container.msg(privateVars.name, 'arrow right click');

                methods.actionMoveSlider('right');
            });

            window.addEventListener('resize', function () {
                cancelAnimationFrame(resizeRAF);

                resizeRAF = requestAnimationFrame(function () {
                    methods.handleWindowResize();
                });
            });

            window.addEventListener('orientationchange', function () {
                cancelAnimationFrame(resizeRAF);

                resizeRAF = requestAnimationFrame(function () {
                    methods.handleWindowResize();
                });
            });

            document.querySelector(publicVars.cssId.containerTouchId).addEventListener('touchstart', function (event) {

                if (event.target.closest(publicVars.cssId.arrowLeftId) || event.target.closest(publicVars.cssId.arrowRightId)) {
                    // If it is, return early to prevent the rest of the code from executing
                    return;
                }

                if (privateVars.touchStarted || privateVars.isAnimating) {
                    return;
                }

                privateVars.touchStart = event.touches[0].clientX;
                privateVars.touchStartY = event.touches[0].clientY;

                privateVars.touchStarted = true;
            });

            document.querySelector(publicVars.cssId.containerTouchId).addEventListener('touchmove', function (event) {
                if (privateVars.touchStarted && !privateVars.isAnimating) {
                    privateVars.touchDiff = event.touches[0].clientX - privateVars.touchStart;
                    privateVars.touchDiffY = event.touches[0].clientY - privateVars.touchStartY;

                    methods.handleTouchMove(privateVars.touchDiff, privateVars.touchDiffY);
                }
            });

            document.querySelector(publicVars.cssId.containerTouchId).addEventListener('touchend', function (event) {
                methods.handleTouchEnd();
            });
        },

        startup: function () {

            const containerHtml = document.querySelector(publicVars.cssId.containerCls);
            const itemsHtml = document.querySelectorAll(publicVars.cssId.itemCls);
            const loaderWrapperHtml = document.querySelector(publicVars.cssId.loaderWrapperCls);
            const outerWrapperHtml = document.querySelector(publicVars.cssId.outerWrapperCls);

            privateVars.itemsSetDeviation = publicVars.itemsSetDeviation || 1;
            privateVars.itemsSetDeviation = Math.min(privateVars.itemsSetDeviation, itemsHtml.length);

            privateVars.itemsCountTillReset = publicVars.itemsCountTillReset || 1;
            privateVars.itemsCountTillReset = Math.min(privateVars.itemsCountTillReset, privateVars.itemsSetDeviation);

            let clonedItemsPrepend = [];
            let clonedItemsAppend = [];


            itemsHtml.forEach((item) => {
                privateVars.items.push(item.cloneNode(true));

                clonedItemsPrepend.push(item.cloneNode(true));
                clonedItemsAppend.push(item.cloneNode(true));
            });

            let clonedItemsPrependReversed = Array.from(clonedItemsPrepend).reverse();
            clonedItemsPrependReversed = clonedItemsPrependReversed.slice(0, privateVars.itemsSetDeviation);

            clonedItemsAppend = clonedItemsAppend.slice(0, privateVars.itemsSetDeviation);

            clonedItemsPrependReversed.forEach((item) => {
                containerHtml.prepend(item);
            });

            clonedItemsAppend.forEach((item) => {
                containerHtml.append(item);
            });

            const updatedItems = document.querySelectorAll(publicVars.cssId.itemCls);

            let itemsIterator = 1;
            updatedItems.forEach((item) => {

                const img = item.querySelector(publicVars.cssId.imageElemCls);

                privateVars.imgPreload.set(itemsIterator, {
                    path: img.dataset.src,
                    preloaded: false
                });

                item.classList.add(publicVars.cssId.itemCls.substring(1) + '' + itemsIterator);

                itemsIterator++;
            });

            privateVars.itemsCount = privateVars.items.length + clonedItemsPrependReversed.length + clonedItemsAppend.length;
            container.msg(privateVars.name, 'items count: ' + privateVars.itemsCount);
            container.msg(privateVars.name, 'items base count: ' + privateVars.items.length);

            if (privateVars.callbacks['beforeLoadEnd'] && typeof privateVars.callbacks['beforeLoadEnd'] === 'function') {
                privateVars.callbacks['beforeLoadEnd']();
                loaderWrapperHtml.style.display = 'none';
            }

            const {itemWidth, modifier, itemsVisible} = methods.calculateCurrentItemsState();

            privateVars.itemsVisible = itemsVisible;

            containerHtml.style.transform = 'translate3d(' + (-(privateVars.itemsSetDeviation * itemWidth) - modifier) + 'px, 0, 0)';

            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    containerHtml.classList.add(publicVars.cssId.isAnimatingCls.substring(1));
                    outerWrapperHtml.classList.remove(publicVars.cssId.isLoadingCls.substring(1));
                    privateVars.isAnimating = false;
                });
            });

            const {first, last} = methods.calculateCurrentItemsState();

            privateVars.firstItem = first;
            privateVars.lastItem = last;
            privateVars.modifier = modifier;
            privateVars.itemWidth = itemWidth;

            container.msg(privateVars.name, 'first item: ' + privateVars.firstItem);
            container.msg(privateVars.name, 'last item: ' + privateVars.lastItem);
            container.msg(privateVars.name, 'item width: ' + privateVars.itemWidth);

            methods.handleArrowsState();
        },

        handleTouchMove: function (diff, diffY) {

            if (Math.abs(diffY) < 100 && Math.abs(diffY) < Math.abs(diff)) {
                const containerElement = document.querySelector(publicVars.cssId.containerCls);

                const translate3dX = -((privateVars.firstItem - 1) * privateVars.itemWidth) - privateVars.modifier;

                const newTranslate3dX = parseInt(translate3dX) + parseInt(diff);

                containerElement.style.transition = 'none';
                containerElement.style.transform = 'translate3d(' + newTranslate3dX + 'px, 0, 0)';

            }

        },

        cleanupTouchValues: function () {
            privateVars.touchStart = 0;
            privateVars.touchDiff = 0;
            privateVars.touchStartY = 0;
            privateVars.touchDiffY = 0;
        },

        handleTouchEnd: function () {

            if (privateVars.touchStarted && !privateVars.isAnimating) {
                let [translate3dX] = methods.getTranslate3d(document.querySelector(publicVars.cssId.containerCls));
                translate3dX = parseInt(translate3dX);

                const containerElement = document.querySelector(publicVars.cssId.containerCls);

                function handleTransitionEnd() {
                    privateVars.isAnimating = false;

                    const {first, last, itemWidth} = methods.calculateCurrentItemsState();

                    const direction = privateVars.touchDiff > 0 ? 'left' : 'right';

                    privateVars.firstItem = first;
                    privateVars.lastItem = last;
                    privateVars.itemWidth = itemWidth;

                    methods.handleArrowsState();
                    methods.preloadImages();
                    methods.handleInfiniteItemsPosition(direction);
                    methods.cleanupTouchValues();
                }

                const {itemsVisible} = methods.calculateCurrentItemsState();

                if (translate3dX >= 0) {
                    privateVars.touchStarted = false;
                    privateVars.isAnimating = true;

                    containerElement.classList.add(publicVars.cssId.isAnimatingCls.substring(1));

                    if(translate3dX === 0) {
                        handleTransitionEnd();
                        return;
                    }

                    containerElement.style.transition = '';
                    containerElement.style.transform = 'translate3d(0, 0, 0)';

                    containerElement.addEventListener('transitionend', function (event) {
                        handleTransitionEnd();
                    }, {once: true});

                } else if (translate3dX <= -((privateVars.itemsCount - itemsVisible) * privateVars.itemWidth) - privateVars.modifier) {
                    privateVars.touchStarted = false;
                    privateVars.isAnimating = true;

                    containerElement.classList.add(publicVars.cssId.isAnimatingCls.substring(1));

                    containerElement.style.transition = '';
                    containerElement.style.transform = 'translate3d(-' + ((privateVars.itemsCount - itemsVisible) * privateVars.itemWidth) - privateVars.modifier + 'px, 0, 0)';

                    if(translate3dX === -((privateVars.itemsCount - itemsVisible) * privateVars.itemWidth) - privateVars.modifier) {
                        handleTransitionEnd();
                        return;
                    }

                    containerElement.addEventListener('transitionend', function (event) {
                        handleTransitionEnd();
                    }, {once: true});
                } else if (translate3dX < 0 && translate3dX > -((privateVars.itemsCount - itemsVisible) * privateVars.itemWidth) - privateVars.modifier) {
                    privateVars.touchStarted = false;
                    privateVars.isAnimating = true;

                    containerElement.classList.add(publicVars.cssId.isAnimatingCls.substring(1));

                    const translate3dX = -((privateVars.firstItem - 1) * privateVars.itemWidth) - privateVars.modifier;

                    // Calculate the number of items moved based on the touch move distance
                    const itemsMoved = Math.round(Math.abs(privateVars.touchDiff) / privateVars.itemWidth);

                    // Calculate the new translate3dX based on the number of items moved
                    let newTranslate3dX = translate3dX;
                    if (privateVars.touchDiff > 0) { // If moving to the right
                        newTranslate3dX += itemsMoved * privateVars.itemWidth;
                    } else { // If moving to the left
                        newTranslate3dX -= itemsMoved * privateVars.itemWidth;
                    }

                    containerElement.style.transition = '';
                    containerElement.style.transform = 'translate3d(' + newTranslate3dX + 'px, 0, 0)';

                    if(translate3dX === newTranslate3dX) {
                        handleTransitionEnd();
                        return;
                    }

                    containerElement.addEventListener('transitionend', function (event) {
                        handleTransitionEnd();
                    }, {once: true});
                } else {
                    privateVars.touchStarted = false;
                    privateVars.isAnimating = false;

                    methods.cleanupTouchValues();
                }

            } else {
                privateVars.touchStarted = false;
                methods.cleanupTouchValues();
            }
        },

        preloadImages: function () {
            container.msg(privateVars.name, 'preload images');

            const {first, last, itemsVisible} = methods.calculateCurrentItemsState();

            const leftPreload = first - (itemsVisible + 1) * 2;
            let leftStartItem = 1;
            let leftRest = 0;

            if(leftPreload > 1) {
                leftStartItem = leftPreload;
            } else {
                leftStartItem = 1;
                leftRest = Math.abs(leftPreload) + 1;
            }

            function handleImagePreload(id) {
                if(privateVars.imgPreload.get(id).preloaded === false) {
                    preloader.preloadSingleImage(privateVars.name, privateVars.imgPreload.get(id).path);
                    privateVars.imgPreload.set(id, {path: privateVars.imgPreload.get(id).path, preloaded: true});

                    const item = document.querySelector(publicVars.cssId.itemCls + '' + id);
                    const img = item.querySelector(publicVars.cssId.imageElemCls);

                    img.src = privateVars.imgPreload.get(id).path;
                }
            }

            for(let i = leftStartItem; i < first; i++) {
                if(privateVars.imgPreload.get(i).preloaded === false) {
                    handleImagePreload(i);
                }
                // console.log('left - ' + i);
            }

            if(leftRest !== 0) {
                for(let i = privateVars.itemsCount; i > (privateVars.itemsCount - leftRest) && i > 0; i--) {
                    handleImagePreload(i);
                    // console.log('leftRest - ' + i);
                }
            }

            const rightPreload = last + (itemsVisible + 1) * 2;
            let rightEndItem = last;
            let rightRest = 0;

            if(rightPreload < privateVars.itemsCount) {
                rightEndItem = rightPreload;
            } else {
                rightEndItem = privateVars.itemsCount;
                rightRest = rightPreload - privateVars.itemsCount;
            }

            for(let i = last + 1; i <= rightEndItem; i++) {
                handleImagePreload(i);
                // console.log('right - ' + i);
            }

            if(rightRest !== 0) {
                for(let i = 1; i <= rightRest; i++) {
                    handleImagePreload(i);
                    // console.log('rightRest - ' + i);
                }
            }

        },

        handleArrowsState: function () {
            //always active don't do anything
        },

        actionMoveSlider: function (direction) {

            const containerElement = document.querySelector(publicVars.cssId.containerCls);
            containerElement.classList.add(publicVars.cssId.isAnimatingCls.substring(1));

            if (privateVars.isAnimating) {
                return;
            }

            if (direction === 'left') {
                if (privateVars.firstItem > 1) {
                    privateVars.firstItem = privateVars.firstItem - privateVars.itemsVisible;
                    privateVars.lastItem = privateVars.lastItem - privateVars.itemsVisible;

                } else {
                    return;
                }
            } else {
                if (privateVars.lastItem < privateVars.itemsCount) {
                    privateVars.firstItem = privateVars.firstItem + privateVars.itemsVisible;
                    privateVars.lastItem = privateVars.lastItem + privateVars.itemsVisible;
                } else {
                    return;
                }
            }

            container.msg(privateVars.name, 'first item: ' + privateVars.firstItem);
            container.msg(privateVars.name, 'last item: ' + privateVars.lastItem);

            privateVars.isAnimating = true;

            methods.handleArrowsState();
            methods.preloadImages();

            const translate3dX = -((privateVars.firstItem - 1) * privateVars.itemWidth) - privateVars.modifier;

            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    containerElement.style.transform = 'translate3d(' + translate3dX + 'px, 0, 0)';
                });
            });

            containerElement.addEventListener('transitionend', function (event) {
                methods.handleInfiniteItemsPosition(direction);
            }, {once: true});
        },

        handleInfiniteItemsPosition: function (direction) {

            const containerHtml = document.querySelector(publicVars.cssId.containerCls);

            if (privateVars.firstItem - privateVars.itemsCountTillReset < 0 && direction === 'left') {

                container.msg(privateVars.name, 'infinite recalculate left');

                let translate3dX = -(((privateVars.firstItem - 1 + privateVars.items.length) * privateVars.itemWidth)) - privateVars.modifier;

                containerHtml.classList.remove(publicVars.cssId.isAnimatingCls.substring(1));
                containerHtml.style.transform = 'translate3d(' + translate3dX + 'px, 0, 0)';

                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        containerHtml.classList.add(publicVars.cssId.isAnimatingCls.substring(1));
                        privateVars.isAnimating = false;

                        const {first, last} = methods.calculateCurrentItemsState();

                        privateVars.firstItem = first;
                        privateVars.lastItem = last;
                    });
                });

            } else if (privateVars.lastItem + privateVars.itemsCountTillReset > privateVars.itemsCount && direction === 'right') {

                container.msg(privateVars.name, 'infinite recalculate right');

                let translate3dX = -(((privateVars.firstItem - 1 - privateVars.items.length) * privateVars.itemWidth)) - privateVars.modifier;
                containerHtml.classList.remove(publicVars.cssId.isAnimatingCls.substring(1));

                containerHtml.style.transform = 'translate3d(' + translate3dX + 'px, 0, 0)';
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        containerHtml.classList.add(publicVars.cssId.isAnimatingCls.substring(1));
                        privateVars.isAnimating = false;

                        const {first, last} = methods.calculateCurrentItemsState();

                        privateVars.firstItem = first;
                        privateVars.lastItem = last;
                    });
                });
            } else {
                privateVars.isAnimating = false;
            }
        },

        calculateCurrentItemsState: function () {
            let isLastItem = false;

            let itemWidth = document.querySelector(publicVars.cssId.itemCls).getBoundingClientRect().width;

            const marginLeft = parseInt(window.getComputedStyle(document.querySelector(publicVars.cssId.itemCls)).marginLeft);
            const marginRight = parseInt(window.getComputedStyle(document.querySelector(publicVars.cssId.itemCls)).marginRight);

            itemWidth += marginLeft + marginRight;

            const containerWidth = document.querySelector(publicVars.cssId.containerCls).getBoundingClientRect().width;

            const itemsInContainer = Math.round(containerWidth / itemWidth);

            const [translate3dXValue] = methods.getTranslate3d(document.querySelector(publicVars.cssId.containerCls));
            const translate3dXComputedValue = methods.getTranslate3d(document.querySelector(publicVars.cssId.containerCls), {computed: true});

            const currentFirst = Math.round(Math.abs(parseInt(translate3dXValue)) / itemWidth) + 1;

            let currentLast = currentFirst + itemsInContainer - 1;

            if (currentLast > privateVars.itemsCount) {
                currentLast = privateVars.itemsCount;
                isLastItem = true;
            }

            return {
                modifier: (marginLeft + marginRight) / 2,
                marginLeft: marginLeft,
                marginRight: marginRight,
                translate3dXValue: translate3dXValue,
                translate3dXComputedValue: translate3dXComputedValue,
                itemWidth: itemWidth,
                containerWidth: containerWidth,
                first: currentFirst,
                last: currentLast,
                itemsVisible: itemsInContainer,
                isLast: isLastItem
            };
        },

        handleWindowResize: function () {
            const {itemWidth, modifier, itemsVisible} = methods.calculateCurrentItemsState();

            privateVars.itemWidth = itemWidth;
            privateVars.modifier = modifier;
            privateVars.itemsVisible = itemsVisible;

            methods.handleArrowsState();
            methods.preloadImages();

            const translate3dX = -((privateVars.firstItem - 1) * privateVars.itemWidth) - privateVars.modifier;

            const containerElement = document.querySelector(publicVars.cssId.containerCls);

            containerElement.classList.remove(publicVars.cssId.isAnimatingCls.substring(1));
            containerElement.style.transform = 'translate3d(' + translate3dX + 'px, 0, 0)';
        },

        getTranslate3d: function (el, config) {

            let transform = null;

            if (config && config.computed) {
                transform = window.getComputedStyle(el).transform;

                const values = transform.split(/\w+\(|\);?/);

                if (!values[1] || !values[1].length) {
                    return [0, 0, 0];
                }

                const valuesComputed = values[1].split(/,\s?/g);

                return parseInt(valuesComputed[4]) || 0;
            } else {
                transform = el.style.transform;

                const values = transform.split(/\w+\(|\);?/);

                if (!values[1] || !values[1].length) {
                    return [0, 0, 0];
                }
                return values[1].split(/,\s?/g);
            }
        },
    }

    return {
        init: function (options) {
            methods.init(options);
        },
        setCallback: function (name, callback) {
            privateVars.callbacks[name] = callback;
        }
    }
}

const factory = {
    objId: 0,

    create: function () {
        factory.objId++;

        return sliderListCut(factory.objId);

    }
}

export default {
    create: factory.create
};